if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const quickSuccess = this.querySelector('.wbquicksuccess');
            if (quickSuccess) quickSuccess.classList.add('hidden');
            this.handleErrorMessage(response.description);
            return;
          }

          if (this.cartNotification) {
            this.cartNotification.renderContents(response);
          } else {
            // Fallback: refresh cart drawer contents and open it (mirrors cart.js logic)
            if (typeof jQuery !== 'undefined') {
              jQuery.get('/cart', function(data) {
                var miniCartBodyHTML = jQuery(data).find('.mini-cart-has-item').html();
                jQuery('.mini-cart-has-item').html(miniCartBodyHTML);
                jQuery('.cartDrawer').removeClass('is-empty');
              });
              // Open the cart drawer
              setTimeout(function() {
                jQuery('body').addClass('no-scroll cartOpen');
                jQuery('.overlay').addClass('cart_overlay');
              }, 50);
              // Update header cart count
              jQuery.getJSON('/cart.js', function(cart) {
                jQuery('.cart-header .count').text(cart.item_count + ' items');
                jQuery('.cart-count').text(cart.item_count);
              });
            }
          }

          const quickSuccess = this.querySelector('.wbquicksuccess');
          if (quickSuccess) quickSuccess.classList.remove('hidden');
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
